module.exports = __webpack_public_path__ + "static/media/mask.e5eeaf47.svg";